export default __webpack_public_path__ + "static/media/Abuget.dba51afc.ttf";